import React, { FC } from 'react';
import EditMembership from './EditMembershipPlan';
import { PopUpModal } from 'shared-components';

interface IProps {
  setIsEdit?: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
  isSettingsFromPortal?: boolean;
}
const EditMembershipPlanComponent: FC<IProps> = ({
  isSettingsFromPortal,
  setIsEdit,
  id,
}) => {
  const handleClose = () => {
    setIsEdit && setIsEdit(false);
  };
  return isSettingsFromPortal ? (
    <PopUpModal
      open={isSettingsFromPortal}
      handleClose={handleClose}
      buttons={[
        {
          buttonType: 'negative',
          buttonLabel: 'Cancel',
          buttonFunction: handleClose,
        },
        {
          buttonType: 'positive',
          buttonLabel: !id ? 'Add' : 'Update',
          form: 'membershipPlan',
          type: 'submit',
        },
      ]}
      heading={`${!id ? 'Add' : 'Update'} Membership Plan`}
      className="flex-container">
      <EditMembership
        setIsEdit={setIsEdit}
        id={id}
        isSettingsFromPortal={isSettingsFromPortal}
      />
    </PopUpModal>
  ) : (
    <EditMembership
      setIsEdit={setIsEdit}
      id={id}
      isSettingsFromPortal={isSettingsFromPortal}
    />
  );
};

export default EditMembershipPlanComponent;
